import { render, staticRenderFns } from "./UserRegisterComponent.vue?vue&type=template&id=52e26ff0&scoped=true&"
import script from "./UserRegisterComponent.vue?vue&type=script&lang=js&"
export * from "./UserRegisterComponent.vue?vue&type=script&lang=js&"
import style0 from "./UserRegisterComponent.vue?vue&type=style&index=0&id=52e26ff0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e26ff0",
  null
  
)

export default component.exports